export enum navigationPages {
  LOGIN = 'login',
  LANDING = 'landing',
  CONFIGURATIONS = 'configurations',
  AGENT_AUTH_EMPLOYEE_NUMBER = 'agent_auth_employee_number',
  AGENT_AUTH_YELLOW_PASSWORD = 'agent_auth_yellow_password',
  AGENT_PROCESS_SELECTION = 'agent_process_selection',
  AGENT_LOCKER_FIX = 'agent_locker_fix',
  CLIENT_RETRIEVAL_SCAN_AWB = 'client_retrieval_scan_awb',
  CLIENT_RETRIEVAL_VERIFICATION_CODE = 'client_retrieval_verification_code',
  CLIENT_RETRIEVAL_NAME = 'client_retrieval_name',
  CLIENT_RETRIEVAL_SIGNATURE = 'client_retrieval_signature',
  CLIENT_RETRIEVAL_PIECE = 'client_retrieval_piece',
  CLIENT_RETRIEVAL_ISSUES = 'client_retrieval_issues',
  INSERT_ISSUES = 'insert_issues',
  INSERT_PIECE = 'insert_piece',
  INSERT_SCAN_PID = 'insert_scan_pid',
  INSERT_PROCESS_SELECTION = 'insert_process_selection',
  REMOVE_ISSUES = 'remove_issues',
  REMOVE_PIECE = 'remove_piece',
  REMOVE_VALIDATE_AWB = 'remove_validate_awb',
  REMOVE_PROCESS_SELECTION = 'remove_process_selection',
  THANK_YOU = 'thank_you',
}

export const userInactivityPages = [
  '',
  navigationPages.LOGIN,
  navigationPages.LANDING,
  navigationPages.CONFIGURATIONS,
  navigationPages.THANK_YOU,
];
